import React from "react";
import { MdOutlineSubscriptions } from "react-icons/md";
import { AiFillStar } from "react-icons/ai";
import { Box, useTheme } from "@mui/material";

function CustomSubscriptionIcon({ size = "25px", active }) {
    const theme = useTheme();
    return (
        <Box position="relative" display="inline-block" width={size} height={size}>
            <MdOutlineSubscriptions style={{ fontSize: size, color: active ? "" : theme.palette.basic.white }} />
            <AiFillStar
                style={{
                    position: "absolute",
                    top: "68%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    fontSize: "11px",
                    color: active ? "" : theme.palette.basic.white,
                }}
            />
        </Box>
    );
}

export default CustomSubscriptionIcon;